import { formatDueDate, formatUTCDateToLocalDate } from './date'
import { ACTION, DATE, NAME } from './Table/types'

const normalizeHour = time => {
  const timeArray = time.split(':')
  if (timeArray[0] > 12) {
    const hour = timeArray[0] - 12
    return `${hour}:${timeArray[1]} PM`
  } else {
    return `${timeArray[0]}:${timeArray[1]} AM`
  }
}

const normalizeTime = datetime => {
  const dateTimeSplit = datetime?.split(' ')
  const time = normalizeHour(dateTimeSplit[3])
  return `${dateTimeSplit[0]} ${dateTimeSplit[1]} ${dateTimeSplit[2]} ${time}`
}

const formatLogs = data => {
  const newData = []
  for (const obj of data) {
    const { action, status, date } = obj
    const { firstName, lastName } = obj?.user
    newData.push({
      ...obj,
      [DATE]: normalizeTime(formatUTCDateToLocalDate(date)),
      [NAME]: `${firstName} ${lastName}`,
      [ACTION]: `${action} ${status}`
    })
  }
  return newData
}

export default formatLogs
